<!--  -->
<template>
    <div class='About_ISFAL'>
        <div class="title_box">
            <img src="../../assets/images/isfal/bg_06.jpg" alt="">
        </div>
        <div class="Certification_System">
            <div class="Certification_System_box">
                <div class="System_box_1">
                    <div class="System_box_1_left">
                        <p class="System_box_1_left_1 " @click="onLeadership">Ravens Speech</p>
                        <p class="System_box_1_left_1 " @click="onOrganizational">Expert Sharing</p>
                        <p class="System_box_1_left_1 active">Professional Publications</p>
                    </div>
                    <div class="System_box_1_right" style="display:flex;flex-wrap:wrap;">
                        <!-- <div class="Methodological">
                            <div class="Methodological_1" v-for="(item,index) in list" :key="index"
                                @click="ondel(item)">{{ item.title }}</div>
                        </div> -->
                        <div v-for="(item,index) in data" :key="index" style="margin-right: 20px;margin-bottom:20px;cursor: pointer;">
                            <img style="width:171px;height:255px;" :src="item.img" alt="" @click="tiaozhuan(item)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: '',
        data() {
            //这里存放数据
            return {
                // list: []
                data:[
                    {
                        img:  require('@/assets/images/isfal/p01.jpg'),
                        id:1,
                        link:'https://www.amazon.co.uk/Action-Learning-Social-Christine-Abbott-ebook/dp/B00GLS72I8/ref=sr_1_3?crid=21KH1NNH6UPYV&keywords=Christine+Abbott&qid=1676795114&s=books&sprefix=christine+abbott%2Cstripbooks%2C289&sr=1-3'
                    },
                    {
                        img:  require('@/assets/images/isfal/p02.jpg'),
                        id:2,
                        link:'https://www.amazon.co.uk/Facilitating-Action-Learning-Practitioners-Guide/dp/0335245978/ref=sr_1_4?crid=21KH1NNH6UPYV&keywords=Christine+Abbott&qid=1676795244&s=books&sprefix=christine+abbott%2Cstripbooks%2C289&sr=1-4'
                    },
                    {
                        img:  require('@/assets/images/isfal/p03.jpg'),
                        id:3,
                        link:"https://www.amazon.com/Action-Learning-Managers-Mike-Pedler-ebook/dp/B0091Q71DI/ref=sr_1_1?crid=1SGYE8MWM2WSD&keywords=action+learning+for+managers&qid=1677563960&s=digital-text&sprefix=%2Cdigital-text%2C434&sr=1-1"
                    },
                    {
                        img:  require('@/assets/images/isfal/p04.jpg'),
                        id:4,
                        link:"https://www.amazon.co.uk/Action-Learning-Social-Taking-Change-ebook/dp/B08PDQ2DYD/ref=sr_1_1?crid=WGP7DGFAVLV6&keywords=Action+Learning+for+Social+Action&qid=1677566054&s=books&sprefix=action+learning+for+social+action%2Cstripbooks%2C1285&sr=1-1"
                    },
                    {
                        img:  require('@/assets/images/isfal/p05.jpg'),
                        id:5,
                        link:"https://www.amazon.co.uk/Action-Learning-Practice-published-January/dp/B017QCCVBA/ref=sr_1_3?crid=25AILCWZ1RHT7&keywords=Mike+Pedler&qid=1676795505&s=books&sprefix=mikepedler%2Cstripbooks%2C658&sr=1-3"
                    },
                    {
                        img:  require('@/assets/images/isfal/p06.jpg'),
                        id:6,
                        link:"https://www.amazon.co.uk/Managers-Leadership-Professional-Business-Management/dp/00771"
                    },
                    {
                        img:  require('@/assets/images/isfal/p07.jpg'),
                        id:7,
                        link:"https://item.jd.com/12528480.html?cu=true&utm_source=api.shop.xuelg.com&utm_medium=jingfen&utm_campaign=t_2011134073_&utm_term=d9f510c1b053477faed80a236e29c6b2"
                    },
                ]
            }
        },
        components: {},

        //方法集合
        methods: {

            tiaozhuan(item){
                window.location.href = item.link;
            },


            artlist() {
                var _this = this;
                _this.$api.artlist({
                    // categoryCode
                    categoryCode:"6N7Bzu"
                }).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        _this.list=res.data.list
                        // this.$message({
                        //     message: '登录成功！',
                        //     type: 'success',
                        // });
                       
                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
            // 跳转详情页   
            ondel(item) {
                this.$router.push('/details/'+item.code)
            },


            onLeadership() {
                this.$router.push('/Ravens_Speech')
            },
            onOrganizational() {
                this.$router.push('/Expert_Sharing')
            },
            onSocial() {
                this.$router.push('/Professional_Publications')
            },
        },
        created() {

        },
        mounted() {
            // this.artlist()
        }
    }
</script>
<style scoped>

</style>